<header role="banner" class:mh-transparent={transparent} class:mh-semitransparent-top={transparent &&
  topTransparencyMode==='semitransparent' } class:mh-fixed={fixed} class:mh-sticky={useStickyClass}
  class="{useScrollColorClassNames ? scrollColorClassNames.hover : colorClassNames.hover} {zIndexClassName}"
  on:click={logClickEvent}
  >
  {#if skipLinkText}
  <a class="mh-skip-link" href="#start-of-content">{skipLinkText}</a>
  {/if}
  <div class="mh-container">
    <div class="mh-brand-wrapper">
      <Brand className={useScrollColorClassNames ? scrollColorClassNames.primary : colorClassNames.primary} {...brand} />
    </div>
    <Navbar colorClassNames={useScrollColorClassNames ? scrollColorClassNames : colorClassNames} {scrollingElementAccessor} items={nav} {user} {desktopAriaLabel}
      {mobileAriaLabel} {brand} {mobileMenu}/>
  </div>
</header>
<div id="start-of-content"></div>

<svelte:window bind:scrollY={scrollY} bind:innerWidth={viewPortWidth} />

<style lang="less">
  @import (less) '@spotify-internal/encore-foundation/web/tokens.css';
  @import (reference) '../../../less/variables.less';
  @import '../../../less/theme-classes.less';

  header {
    position: relative;
    top: 0;
    right: 0;
    left: 0;

    font-family: @masthead-font-family-default;
    font-size: @masthead-font-size-medium;
    font-weight: @masthead-font-weight-normal;
    line-height: 1.5;

    background: var(--solid-black-0);
    min-height: 54px;
  }

  header.mh-default-z-index {
    z-index: @zindex-sticky;
  }

  header .mh-skip-link {
    background: var(--solid-white-200);
    border-radius: 500px;
    color: var(--gray-7);
    clip: rect(1px, 1px, 1px, 1px);
    display: block;
    font-weight: @masthead-font-weight-bold;
    height: 1px;
    margin: 16px;
    overflow: hidden;
    padding: 16px 48px;
    position: absolute;
    text-decoration: none;
    text-transform: uppercase;
    width: 1px;
    z-index: 1;

    &:focus {
      clip: auto;
      height: auto;
      width: auto;
    }
  }

  @media (min-width: @breakpoint-tablet) {
    header.mh-transparent:not(.mh-semitransparent-top) {
      background-color: transparent;
      transition: background-color 200ms linear;
      min-height: 80px;

      &.mh-sticky {
        background-color: @masthead-header-transparency;
      }
    }

    header.mh-semitransparent-top {
      background-color: @masthead-header-transparency;
    }
  }

  header.mh-fixed {
    position: fixed;
  }

  :lang(ar) {
    font-family: @masthead-font-family-default-ar !important;
    letter-spacing: 0 !important;
  }

  /* Language Urdu uses the same font and font fallbacks as Arabic. */
  :lang(ur) {
    font-family: @masthead-font-family-default-ar !important;
    letter-spacing: 0 !important;
  }

  :lang(he) {
    font-family: @masthead-font-family-default-hbr !important;
    letter-spacing: 0 !important;
  }

  :lang(ru) {
    font-family: @masthead-font-family-default-cyr !important;
    letter-spacing: 0 !important;
  }

  :lang(ko) {
    font-family: @masthead-font-family-default-han !important;
  }

  :lang(el) {
    font-family: @masthead-font-family-default-el !important;
  }

  :lang(hi),
  :lang(ne) {
    font-family: @masthead-font-family-default-deva !important;
  }


  .mh-brand-wrapper {
    display: inline-block;

    margin-top: 13px;

    @media (min-width: @breakpoint-tablet) {
      margin-top: 20px;
    }
  }

  .mh-container {
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;

    margin: 0 auto;
    padding: 0 15px;

    max-width: @page-width-mobile;
    height: 54px;

    @media (min-width: @breakpoint-tablet) {
      max-width: @page-width-tablet;
      height: 80px;
    }

    @media (min-width: @breakpoint-desktop) {
      max-width: @page-width-desktop;
    }
  }
</style>

<script>
  import Brand from '../../shared/Brand.html';
  import Navbar from './Navbar.html';
  import breakpoints from '../../../constants/breakpoints.json';
  import logClickEvent from '../../../lib/logClickEvent';

  export let zIndexClassName;
  export let colorClassNames;
  export let scrollColorClassNames;
  export let transparent;
  export let topTransparencyMode;
  export let fixed;
  export let scrollingElementAccessor;
  export let brand = null;
  export let user = null;
  export let desktopAriaLabel = null;
  export let mobileAriaLabel = null;
  export let nav = null;
  export let mobileMenu = null;
  export let skipLinkText = null;

  $: colorClassNames = Object.assign({
    primary: 'mh-header-primary',
    secondary: 'mh-header-secondary',
    hover: 'mh-header-hover',
  }, colorClassNames,);

  $: scrollColorClassNames = Object.assign({
    primary: colorClassNames.primary,
    secondary: colorClassNames.secondary,
    hover: colorClassNames.hover,
  }, scrollColorClassNames);

  let scrollY;
  let viewPortWidth;

  $: useStickyClass = scrollY > 30 && fixed;
  $: useScrollColorClassNames = scrollY > 30 && fixed && viewPortWidth > breakpoints['breakpoint-tablet'];
</script>